export const OrderStatus = {
	CREATED:    'created',
	CONFIRMED:  'confirmed',
	FAILED:     'failed',
	REFUNDED:   'refunded',
	CHARGEBACK: 'chargeback',
};
